import React from 'react';
import { FaAward, FaUserGraduate } from 'react-icons/fa';
import './BestPaperPage.css';

const researchThemes = [
  'Artificial Intelligence in Structural Engineering',
  'Bridge Engineering/Wind Engineering',
  'Composite Structures and Additively Manufactured Structures',
  'Computational Mechanics and Structural Optimisation',
  'Concrete and Masonry Structures',
  'Earthquake Engineering/Structure Resilience',
  'Marine and Offshore Structures',
  'Novel Structures and Metamaterials',
  'Structural Control and Health Monitoring',
  'Steel and Space Structures',
  'Structures Under Extreme Loading (Impact, Blast and Fire etc)',
  'Structural Analysis and Design',
  'Structural Reliability and Life Circle Assessment',
  'Sustainable and Green Structures (Timber and Bamboo etc)',
];

const BestPaperPage = () => {
  return (
    <section className="bestpaper-page fade-in-up">
      <div className="bestpaper-wrapper">
        <span className="badge bestpaper-badge">Awards</span>
        <h1 className="bestpaper-heading">Best Paper Awards</h1>
        <p className="bestpaper-subtitle">
          The ICES2026 Conference will establish an Award Selection Committee comprising Editorial Board Members of the journal <strong>Engineering Structures</strong> and members of the conference organising committee to assess the quality of full papers submitted to the conference.
        </p>

        {/* Eligibility */}
        <div className="bestpaper-section">
          <div className="bestpaper-section-header">
            <div className="bestpaper-section-icon eligibility-icon">
              <FaAward />
            </div>
            <h2 className="bestpaper-section-title">Eligibility</h2>
          </div>
          <p className="bestpaper-section-text">
            To be eligible for the Best Paper Awards and Best Student Paper Awards, full papers must be submitted to ICES2026, registered for the award competition, and presented at the conference by one of the authors.
          </p>
        </div>

        {/* Research Themes */}
        <div className="bestpaper-section">
          <div className="bestpaper-section-header">
            <div className="bestpaper-section-icon themes-icon">
              <FaAward />
            </div>
            <h2 className="bestpaper-section-title">Research Themes</h2>
          </div>
          <p className="bestpaper-section-text">
            ICES2026 is expected to present one Best Paper Award and one Best Student Paper Award for each of the following research themes:
          </p>
          <div className="bestpaper-themes-list">
            {researchThemes.map((theme, index) => (
              <div className="bestpaper-theme-item" key={index}>
                <div className="bestpaper-theme-number">{index + 1}</div>
                <span>{theme}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Student Paper Note */}
        <div className="bestpaper-note">
          <div className="bestpaper-note-icon">
            <FaUserGraduate />
          </div>
          <div className="bestpaper-note-text">
            <strong>Best Student Paper Award:</strong> To be eligible, the student must be the first or corresponding author of the full paper and must present the paper at the conference.
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestPaperPage;
